import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { Phone, Plus, Minus } from "lucide-react";
import { useState } from "react";

const FAQS = [
  {
    question: "What types of services do you offer?",
    answer:
      "We provide a wide range of services to meet your needs, including installation, maintenance, and repair solutions. Each service is delivered by skilled professionals using the latest techniques.",
  },
  {
    question: "Do you offer emergency services?",
    answer:
      "Yes, our team is available for urgent service needs. We respond quickly and efficiently to minimize downtime and address issues safely and effectively.",
  },
  {
    question: "How do you ensure high-quality results?",
    answer:
      "Every project is handled with precision and care. Our team follows strict quality protocols, uses professional-grade tools, and focuses on delivering lasting and reliable results.",
  },
  {
    question: "Are your services customizable?",
    answer:
      "Absolutely. We tailor our solutions to your specific requirements. From scheduling to service scope, we work closely with you to ensure the outcome meets your expectations.",
  },
  {
    question: "Do you provide transparent pricing?",
    answer:
      "Yes. We offer clear, upfront estimates and detailed explanations of our services. You will always know what to expect without hidden fees or surprises.",
  },
  {
    question: "How do you prioritize customer satisfaction?",
    answer:
      "Customer satisfaction is at the heart of our services. We focus on communication, professionalism, and quality to ensure each client has a smooth and positive experience.",
  },
];
export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faqs" className="max-w-[90%] xl:max-w-6xl mx-auto space-y-12">

      {/* Header row */}
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
            FAQs
          </div>
          <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
            What People Ask
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
            Our services are built on trust, skill, and attention to detail. Honest, direct answers — every time.
          </p>
        </div>

        {/* Desktop CTA */}
          

      {/* Accordion */}
      <div className="space-y-3 w-full">
        {FAQS.map((faq, i) => (
          <div
            key={i}
            className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden"
          >
            <button
              onClick={() => toggle(i)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span className="font-bold text-gray-900 text-[15px] leading-snug">
                {faq.question}
              </span>
              <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-200 ${openIndex === i ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-500"}`}>
                {openIndex === i
                  ? <Minus className="w-4 h-4" />
                  : <Plus className="w-4 h-4" />}
              </span>
            </button>

            {openIndex === i && (
              <div className="px-6 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
<div className="mt-6 bg-blue-50 border border-blue-100 rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
  <div>
    <h3 className="font-black text-gray-900 text-xl leading-tight">Still have questions?</h3>
    <p className="text-gray-500 text-sm mt-1">Our team is happy to help — reach out anytime.</p>
  </div>
  <PrimaryButton />
</div>
    </section>
  );
}
